import * as style from "../../style";

// Apply symbol styling in two.js terms
const { green, red, white, black } = style.Color;

const symbolStyleTable: style.StyleTable = {
  shape: {
    //       light light    dark  dark
    //       no    hilited  no    hilited
    fill: style.Special.None,
    stroke: [green, black, green, white],
    linewidth: [2, 3, 2, 3],
    cap: "round",
    join: "round",
  },
  text: {
    family: style.THE_FONT,
    style: "normal",
    weight: [700, 700, 700, 700], // Typical value for "bold"
    size: [16, 16, 16, 16],
    fill: [red, black, red, white],
    stroke: style.Special.None,
  },
};

// Selection Boxes have a few "variants":
// They are always enabled when editing Symbols,
// and are only displayed on Instances when they are highlighted.
// The rest of their style is shared.
const symbolSelectionBoxStyleTable: style.ShapeStyleTable = {
  //       light light    dark  dark
  //       no    hilited  no    hilited
  hidden: false, // Always visible, for symbol editing
  fill: style.Special.None,
  stroke: style.Color.red,
  linewidth: 1,
  cap: "round",
  join: "round",
};
const instanceSelectionBoxStyleTable: style.ShapeStyleTable = {
  ...symbolSelectionBoxStyleTable,
  hidden: [true, false, true, false], // Note invisible when not highlighted
};

// Collected styling functions
export const StyleTables = {
  symbol: symbolStyleTable,
  symbolSelectionBox: symbolSelectionBoxStyleTable,
  instanceSelectionBox: instanceSelectionBoxStyleTable,
};
